import React, {useEffect, useState} from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, EffectCoverflow, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import "./Easystyle.css";
import { IoArrowBackOutline, IoArrowForwardOutline } from "react-icons/io5";
import Getstarted from "../../GetStarted/Getstarted";
//import JoinPriorityWaitlistBtn from "../../ViralLoops/JoinPriorityWaitlistBtn";

const EasySetup = () => {

  const [showGetstarted, setShowGetstared] = useState(false);

  const [coverflowEffect, setCoverflowEffect] = useState({
    rotate: 0,
    stretch: 0,
    depth: 410,
    modifier: 2.5,
  });

  const [key, setKey] = useState(0); // Force re-render

  // Function to update effect based on screen size
  const updateEffect = () => {
    const width = window.innerWidth;

    let newEffect;
    if (width > 1400) {
      newEffect = { rotate: 0, stretch: 0, depth: 410, modifier: 2.5 };
    } else if (width > 1200) {
      newEffect = { rotate: 0, stretch: 0, depth: 478, modifier: 2.5 };
    } else if (width > 992) {
      newEffect = { rotate: 0, stretch: 0, depth: 600, modifier: 2.5 };
    } else {
      newEffect = { rotate: 0, stretch: 0, depth: 430, modifier: 2.5 };
    }

    setCoverflowEffect(newEffect);
    setKey((prevKey) => prevKey + 1); 
  };

  useEffect(() => {
    updateEffect();
    window.addEventListener("resize", updateEffect);
    return () => window.removeEventListener("resize", updateEffect);
  }, []);

console.log(coverflowEffect,'this is cover effect')
  return (
    <section className="trendingSliderMain" id="trending">
           <Getstarted
        showJoinWaitList={showGetstarted}
        onClose={() => setShowGetstared(false)}
        onOpen={() => setShowGetstared(true)}
        />
      <div className="container">
          <div className='row align-items-center'>
            <div className='col-lg-12 col-md-12 col-sm-12'>
                <div className='trendingSliderHead'>
                    <h2>On-board to on-rent in <span>less than 60 minutes</span></h2>
                    <h3>Get Started In 5 Simple Steps</h3>
                    <p>No complicated setup, no guesswork—just a seamless platform that lets you focus on revenue and renters coming back.</p>
                </div>
              </div>
          </div>

          {/* <div className="trendingSliderOuter phone-treandin-slides d-none">                  
            <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-indicators">
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="4" aria-label="Slide 5"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="5" aria-label="Slide 6"></button>

                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <img src="/img/step-slide-left-arrow.png" className="" alt="Step Arrow"/>
                    </button>
                     <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                     <img src="/img/step-slide-right-arrow.png" className="" alt="Step Arrow"/>
                     <span className="visually-hidden">Next</span>
                     </button>
                </div>
                
                

                <div className="carousel-inner">
                    <div className="carousel-item active">
                    <img src="/img/AnoucementPage/get-started-step-1.webp" className="d-block w-100" alt="Step Images"/>
                    </div>
                    <div className="carousel-item">
                    <img src="/img/AnoucementPage/get-started-step-2.webp" className="d-block w-100" alt="Step Images"/>
                    </div>
                    <div className="carousel-item">
                    <img src="/img/AnoucementPage/get-started-step-3.webp" className="d-block w-100" alt="Step Images"/>
                    </div>
                    <div className="carousel-item">
                    <img src="/img/AnoucementPage/get-started-step-4.webp" className="d-block w-100" alt="Step Images"/>
                    </div>
                    <div className="carousel-item">
                    <img src="/img/AnoucementPage/get-started-step-5.webp" className="d-block w-100" alt="Step Images"/>
                    </div>
                    <div className="carousel-item">
                    <img src="/img/AnoucementPage/get-started-step-6.webp" className="d-block w-100" alt="Step Images"/>
                    </div>
                </div>
                
            </div>
          </div>  */}




          <div className="trendingSliderOuter phone-slider-hidee">
                  <Swiper
                    key={key} // Force re-render on change
                    effect="coverflow"
                    grabCursor={true}
                    centeredSlides={true}
                    loop={true}
                    slidesPerView="auto"
                    coverflowEffect={coverflowEffect}
                    // coverflowEffect={{ rotate: 0, stretch: 0, depth: 410, modifier: 2.5 }} // 1400 above
                   //coverflowEffect={{ rotate: 0, stretch: 0, depth: 478, modifier: 2.5 }} // 1400 below
                   // coverflowEffect={{ rotate: 0, stretch: 0, depth: 600, modifier: 2.5 }} // 1200 below
                   // coverflowEffect={{ rotate: 0, stretch: 0, depth: 430, modifier: 2.5 }} // 992 below
                    pagination={{ clickable: true }}
                    navigation={{ nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" }}
                    autoplay={{ delay: 3000, disableOnInteraction: false }}
                    allowTouchMove={true}
                    speed={1000}
                    modules={[Navigation, Pagination, EffectCoverflow, Autoplay]}
                    className="trending-slider"
                  >
                  <SwiperSlide 
                      className="swiper-slide trending-slide"  
                      style={{ backgroundImage: "url('/img/AnoucementPage/step_1.webp')", backgroundPosition: 'center' }}>
                      <div className="trendingInner trendingInner_1">
                          <h2>Create your account</h2>
                          <p>Takes up to 5 mins.</p>
                          {/* <div className="steps_1">1</div>
                          <div className="steps_2">Step</div> */}
                          <img src="/img/AnoucementPage/step_1_table.webp" alt=""/>
                      </div>
                      <div className="trendingMobile">
                        <img src="/img/AnoucementPage/get-started-step-1.webp" className="d-block w-100" alt="Step Images"/>
                      </div>
                  </SwiperSlide>

                  <SwiperSlide 
                      className="swiper-slide trending-slide"  
                      style={{ backgroundImage: "url('/img/AnoucementPage/step_2.webp')"}}>
                      <div className="trendingInner trendingInner_2">
                          <h2>Manage your platfrom <br/>settings</h2>
                          <p>Takes up to 15 mins.</p>
                          <img  src="/img/AnoucementPage/toggles.webp" alt=""/>
                      </div>
                      <div className="trendingMobile">
                        <img src="/img/AnoucementPage/get-started-step-2.webp" className="d-block w-100" alt="Step Images"/>
                      </div>
                  </SwiperSlide>

                  <SwiperSlide 
                      className="swiper-slide trending-slide"  
                      style={{ backgroundImage: "url('/img/AnoucementPage/step_3.webp')" }}>
                      <div className="trendingInner trendingInner_3">
                          <h2>Create your free website <span>or add our embed link to your site</span> </h2>
                          <p>Takes up to 15 mins.</p>
                          <img src="/img/AnoucementPage/classic.webp" alt=""/>
                      </div>
                      <div className="trendingMobile">
                        <img src="/img/AnoucementPage/get-started-step-3.webp" className="d-block w-100" alt="Step Images"/>
                      </div>
                  </SwiperSlide>


                  <SwiperSlide 
                      className="swiper-slide trending-slide"  
                      style={{ backgroundImage: "url('/img/AnoucementPage/step_4.webp')" }}>
                      <div className="trendingInner trendingInner_4">
                          <h2 className="whiteSpan">Add your vehicle</h2>
                          <p className="whiteSpan">Takes up to 5 mins.</p>
                          <img  src="/img/AnoucementPage/info.webp" alt=""/>
                      </div>
                      <div className="trendingMobile">
                        <img src="/img/AnoucementPage/get-started-step-4.webp" className="d-block w-100" alt="Step Images"/>
                      </div>
                  </SwiperSlide>


                  <SwiperSlide 
                      className="swiper-slide trending-slide"  
                      style={{ backgroundImage: "url('/img/AnoucementPage/get-started-step-5.webp')" }}>
                      {/* <div className="trendingInner trendingInner_5">
                          <h2 className="whiteSpan">Connect your <br/>Stripe Account</h2>
                          <p className="whiteSpan">Takes up to 5 mins.</p> 
                          <a href="#" className="btn"><img className="dollar" src="/img/AnoucementPage/dollar.svg" alt="icon"/> 
                          <span>Go to Stripe</span>
                          <img src="/img/arrow_spl.svg" alt="icon"/>
                          </a>
                      </div>
                      <div className="trendingMobile">
                        <img src="/img/AnoucementPage/get-started-step-5.webp" className="d-block w-100" alt="Step Images"/>
                      </div> */}
                  </SwiperSlide>


                  <SwiperSlide 
                      className="swiper-slide trending-slide"  
                      style={{ backgroundImage: "url('/img/AnoucementPage/step_6.webp')" }}>
                      <div className="trendingInner trendingInner_6">
                          <h2>Start generating income</h2>
                          <div className="trendingInner_6_data">
                            <p>Your business, <br/>you’re in control.</p>
                            <img src="/img/AnoucementPage/rentsuccess_refund_process.webp" alt=""/>
                          </div>
                      </div>
                      <div className="trendingMobile">
                        <img src="/img/AnoucementPage/get-started-step-6.webp" className="d-block w-100" alt="Step Images"/>
                      </div>
                  </SwiperSlide>
                  {/* end */}
                  
                  </Swiper>
                  <div className="trending-slider-control">
                    <div className="swiper-button-prev slider-arrow">
                      <IoArrowBackOutline />
                    </div>
                    <div className="swiper-button-next slider-arrow">
                      <IoArrowForwardOutline />
                    </div>
                    <div className="swiper-pagination"></div>
                  </div>
          </div>
          <div className="trendingSliderOuter">
            <button className="btn btnGradient_3" onClick={() => setShowGetstared(true)}>Get Started</button>
            {/* <JoinPriorityWaitlistBtn buttonClass="btn btnGradient_3" buttonText="Get Started" /> */}
          </div>

          
        



      </div>
    </section>
  );
};

export default EasySetup;
